import { endpoints, host } from '@config/endpoints';
import axios, { CancelTokenSource } from 'axios';
import request, { Cancelled } from './request';

var getJobSourcesCancelToken: CancelTokenSource;

export const getJobSources = async (HubIds: string[], ISICCodes: string[], ISCO2Codes: string[], ISCED4Codes: string[], Locations?: string[], fromQuarter?: string, toQuarter?: string, isEntryLevel?: boolean) => {
    const { path, method } = endpoints.dashboard.getJobSources;

    getJobSourcesCancelToken && getJobSourcesCancelToken.cancel();
    const source = axios.CancelToken.source();
    getJobSourcesCancelToken = source;

    let err = null;
    let res: any = null;
    let options = {};
    if (getJobSourcesCancelToken.token)
        options = { cancelToken: getJobSourcesCancelToken.token };

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { HubIds, ISICCodes, ISCO2Codes, ISCED4Codes, Locations, fromQuarter, toQuarter, isEntryLevel },
            options,
        ));
    } catch (error) {
        if (axios.isCancel(error)) {
            err = Cancelled;
        }
        else {
            // @ts-ignore
            err = error.message;
        }
    }

    return [err, res];
};
